// import { SearchToolOrderInput } from '@bechtel/ht-types';
import { useMutation } from '@apollo/client';
import { UpdateUserAccountInput, UpdateUserAccountResult } from '@bechtel/ht-types';
import { useCallback } from 'react';
import { UPDATE_USER } from '~/gql/user';

export const useUpdateUser = (refetchQueries = []) => {
  const [updateUserQuery, { data, loading, error }] = useMutation<
    { updateUserAccount: UpdateUserAccountResult },
    { updateUserAccountInput: UpdateUserAccountInput }
  >(UPDATE_USER, {
    refetchQueries: refetchQueries,
  });

  const updateUserAccount = useCallback(
    (updateUserAccountInput: UpdateUserAccountInput, onComplete?: (data) => void, onError?: (err) => void) => {
      updateUserQuery({
        variables: {
          updateUserAccountInput: {
            ...updateUserAccountInput,
            upn: updateUserAccountInput.upn ? btoa(updateUserAccountInput.upn) : null,
          },
        },
        onCompleted: (data) => {
          if (onComplete) {
            onComplete(data.updateUserAccount);
          }
        },
        onError: (err) => {
          if (onError) {
            onError(err);
          }
        },
      });
    },
    [updateUserQuery]
  );

  return { updateUserAccount, data, loading, error };
};
